import { DateTime } from "luxon";
import { BLANK } from "./global";

export const DUE_DATE_WEEK       = 40;
export const WEEK_DISPLAY_CUTOFF = 40;

/** JS days are Sun=0 to Sat=6. Luxon days are Mon=0 to Sun=6 */
export const convertDayJsToLuxon = (jsDay: number) => (jsDay + 6) % 7;
/** Luxon days are Mon=0 to Sun=6. JS days are Sun=0 to Sat=6 */
export const convertDayLuxonToJs = (luxDay: number) => (luxDay + 1) % 7;

// export const getISO = (dt?: DateTime | null) => dt?.toUTC().toISO({ includeOffset: false }) || undefined;

export const dateToString = (dt: DateTime) => dt.toLocal().toLocaleString(DateTime.DATE_SHORT);
export const timeToString = (dt: DateTime, includeSeconds: boolean = false) => dt.toLocal().toLocaleString(includeSeconds ? DateTime.TIME_WITH_SECONDS : DateTime.TIME_SIMPLE);
export const dateTimeToString = (dt: DateTime, includeSeconds: boolean = false) => dt.toLocal().toLocaleString(includeSeconds ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT);

export const isoDateTimeToLuxon = (isoDateTime: string) => DateTime.fromISO(isoDateTime, { zone: 'utc' }).toLocal();
export const isoDateTimeToLuxonUndef = (isoDateTime?: string) => !!isoDateTime ? DateTime.fromISO(isoDateTime, { zone: 'utc' }).toLocal() : undefined;
export const isoDateTimeToDate = (isoDateTime: string) => dateToString(isoDateTimeToLuxon(isoDateTime));
export const isoDateTimeToTime = (isoDateTime: string) => timeToString(isoDateTimeToLuxon(isoDateTime));
export const isoDateTimeToDateTime = (isoDateTime: string) => dateTimeToString(isoDateTimeToLuxon(isoDateTime));

///////

export const dateToIsoString      = (dt?: DateTime | null) => dt?.toSQLDate() || undefined;
export const dateTimeToIsoString  = (dt?: DateTime | null, suppressMilliseconds: boolean = false) => dt?.toUTC().toISO({ includeOffset: false, suppressMilliseconds }) || undefined;
// export const dateToString         = (dt?: DateTime | null)                      => dt?.toLocaleString(DateTime.DATE_SHORT) || undefined;
// export const timeToString         = (dt?: DateTime | null, showSeconds = false) => dt?.toLocaleString(showSeconds ? DateTime.TIME_WITH_SECONDS           : DateTime.TIME_SIMPLE)    || undefined;
// export const dateTimeToString     = (dt?: DateTime | null, showSeconds = false) => dt?.toLocaleString(showSeconds ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT) || undefined;

// export const isoDateTimeToLuxon = (iso: string, utc = false) => {
//   let dt = DateTime.fromISO(iso, { zone: 'utc' });
//   if (!utc) { dt = dt.toLocal(); }
//   return dt;
// }
// export const isoDateTimeToLuxonUndef = (iso?: string, utc = false) => iso ? isoDateTimeToLuxon(iso, utc) : undefined;

// export const isoDateToString      = (iso?: string, utc = false)                      => iso ? dateToString(    isoDateTimeToLuxon(iso, utc)) : undefined;
// export const isoTimeToString      = (iso?: string, utc = false, showSeconds = false) => iso ? timeToString(    isoDateTimeToLuxon(iso, utc), showSeconds) : undefined;
// export const isoDateTimeToString  = (iso?: string, utc = false, showSeconds = false) => iso ? dateTimeToString(isoDateTimeToLuxon(iso, utc), showSeconds) : undefined;

// export const setTimeToStartOfDay = (dateTime: DateTime) => {
//   return dateTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
// }

// export const setTimeToEndOfDay = (dateTime: DateTime) => {
//   return dateTime.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
// }

export const calcPregnancyWeek = (dueDate: DateTime) => {
  return Math.max(0, Math.floor(DUE_DATE_WEEK - dueDate.diffNow('weeks').weeks));
}

export const pregnancyWeekToString = (week: number, onlyNumber: boolean = false) => {
  if (week <= 0) {
    return BLANK;
  }
  
  // const value = week > WEEK_DISPLAY_CUTOFF ? `${WEEK_DISPLAY_CUTOFF}+` : week.toString();
  const value = week.toString();

  return onlyNumber ? value : `Week ${value}`;
}

export const getDiffDays = (timestamp: string) => {
  const submitTime  = DateTime.fromISO(timestamp, {zone: 'utc'}).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const diff        = Math.floor(Math.abs(submitTime.diffNow('days').days));

  return diff;
}
